import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import {
  CreateFieldPayload,
  CreateFieldResponse,
  CreateSummaryFieldPayload,
  DependentFields,
  DependentFieldsSuccess,
  Field,
  FieldDependencies,
  FieldType,
  UpdateFieldPayload,
  UpdateSummaryFieldPayload,
  CreateLookupFieldsPayload
} from '../_models/field.model';
import { FormField } from '../_models/form.model';

/**
 * Field action types
 */
export enum FieldActionTypes {
  LOAD_FIELD = '[Field] Load Field',
  LOAD_FIELD_SUCCESS = '[Field] Load Field Success',
  LOAD_FIELD_FAILED = '[Field] Load Field Failed',
  LOAD_FIELDS = '[Field] Load Fields',
  LOAD_FIELDS_SUCCESS = '[Field] Load Fields Success',
  LOAD_FIELDS_FAILED = '[Field] Load Fields Failed',
  LOAD_FIELD_TYPES = '[Field] Load Field Types',
  LOAD_FIELD_TYPES_SUCCESS = '[Field] Load Field Types Success',
  LOAD_FIELD_TYPES_FAILED = '[Field] Load Field Types Failed',
  CREATE_FIELD = '[Field] Create Field',
  CREATE_FIELD_SUCCESS = '[Field] Create Field Success',
  CREATE_FIELD_FAILED = '[Field] Create Field Failed',
  CREATE_MULTIPLE_FIELD = '[Field] Create Multiple Fields',
  CREATE_MULTIPLE_FIELD_SUCCESS = '[Field] Create Multiple Fields Success',
  CREATE_MULTIPLE_FIELD_FAILED = '[Field] Create Multiple Fields Failed',
  DELETE_FIELD = '[Field] Delete Field',
  DELETE_FIELD_SUCCESS = '[Field] Delete Field Success',
  DELETE_FIELD_FAILED = '[Field] Delete Field Failed',
  UPDATE_FIELD = '[Field] Update Field',
  UPDATE_FIELD_SUCCESS = '[Field] Update Field Success',
  UPDATE_FIELD_FAILED = '[Field] Update Field Failed',
  LOAD_LOOKUP_FIELDS = '[Field] Load Lookup Fields',
  LOAD_LOOKUP_FIELDS_SUCCESS = '[Field] Load Lookup Fields Success',
  LOAD_LOOKUP_FIELDS_FAILED = '[Field] Load Lookup Fields Failed',
  LOAD_SUMMARY_FIELDS = '[Field] Load Summary Field',
  LOAD_SUMMARY_FIELDS_SUCCESS = '[Field] Load Summary Field Success',
  LOAD_SUMMARY_FIELDS_FAILED = '[Field] Load Summary Field Failed',
  LOAD_SUMMARIZABLE_FIELDS = '[Field] Load Summarizable Fields',
  LOAD_SUMMARIZABLE_FIELDS_SUCCESS = '[Field] Load Summarizable Fields Success',
  LOAD_SUMMARIZABLE_FIELDS_FAILED = '[Field] Load Summarizable Fields Failed',
  LOAD_FIELD_DEPENDENCIES = '[Field] Load Field Dependencies',
  LOAD_FIELD_DEPEDENCIES_SUCCESS = '[Field] Load Field Dependencies Success',
  LOAD_FIELD_DEPENDENCIES_FAILED = '[Field] Load Field Dependencies Failed',
  LOAD_DEPENDENT_FIELDS = '[Field] Load Dependent Fields',
  LOAD_DEPENDENT_FIELDS_SUCCESS = '[Field] Load Dependent Fields Success',
  LOAD_DEPENDENT_FIELDS_FAILED = '[Field] Load Dependent Fields Failed',
  LOAD_SUMMARY_FORM_FIELD = '[Field] Load Summary Form Field',
  LOAD_SUMMARY_FORM_FIELD_SUCCESS = '[Field] Load Summary Form Field Success',
  LOAD_SUMMARY_FORM_FIELD_FAILED = '[Field] Load Summary Form Field Failed',
  CREATE_LOOKUP_FIELDS = '[Field] Create Lookups',
  CREATE_LOOKUP_FIELDS_SUCCESS = '[Field] Create Lookups Success',
  CREATE_LOOKUP_FIELDS_FAILED = '[Field] Create Lookups Failed',
  RESET = '[Field] RESET',
}

/**
 * Operations
 */
export class LoadField implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD;

  constructor(
    public tableId: string,
    public fieldId: string,
    public force: boolean = false
  ) {}
}

export class LoadFieldSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_SUCCESS;

  constructor(
    public tableId: string,
    public fieldId: string,
    public payload: Field
  ) {}
}

export class LoadFieldFailed implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadFields implements Action {
  readonly type = FieldActionTypes.LOAD_FIELDS;

  constructor(public tableId: string, public force: boolean = false) {}
}

export class LoadFieldsSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_FIELDS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Field>) {}
}

export class LoadFieldsFailed implements Action {
  readonly type = FieldActionTypes.LOAD_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadFieldTypes implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_TYPES;

  constructor() {}
}

export class LoadFieldTypesSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_TYPES_SUCCESS;

  constructor(public payload: Array<FieldType>) {}
}

export class LoadFieldTypesFailed implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_TYPES_FAILED;

  constructor(public payload: Error) {}
}

export class CreateField extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_FIELD;

  constructor(public payload: CreateFieldPayload | CreateSummaryFieldPayload) {
    super();
  }
}

export class CreateFieldSuccess extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_FIELD_SUCCESS;

  constructor(public payload: CreateFieldResponse) {
    super();
  }
}

export class CreateFieldFailed extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_FIELD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class CreateLookupFields extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_LOOKUP_FIELDS;

  constructor(public payload: CreateLookupFieldsPayload) {
    super();
  }
}

export class CreateLookupFieldsSuccess extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_LOOKUP_FIELDS_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class CreateLookupFieldsFailed extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_LOOKUP_FIELDS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateMultipleFields extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_MULTIPLE_FIELD;

  constructor(public payload: Array<CreateFieldPayload> | Array<CreateSummaryFieldPayload>) {
    super();
  }
}

export class CreateMultipleFieldsSuccess extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_MULTIPLE_FIELD_SUCCESS

  constructor(public payload: Array<CreateFieldResponse>) {
    super();
  }
}

export class CreateMultipleFieldsFailed extends Reference implements Action {
  readonly type = FieldActionTypes.CREATE_MULTIPLE_FIELD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteField extends Reference implements Action {
  readonly type = FieldActionTypes.DELETE_FIELD;

  constructor(public tableId: string, public fieldId: string) {
    super();
  }
}

export class DeleteFieldSuccess extends Reference implements Action {
  readonly type = FieldActionTypes.DELETE_FIELD_SUCCESS;

  constructor(public tableId: string, public fieldId: string) {
    super();
  }
}

export class DeleteFieldFailed extends Reference implements Action {
  readonly type = FieldActionTypes.DELETE_FIELD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateField extends Reference implements Action {
  readonly type = FieldActionTypes.UPDATE_FIELD;

  constructor(public payload: UpdateFieldPayload | UpdateSummaryFieldPayload, public isForLookup = false) {
    super();
  }
}

export class UpdateFieldSuccess extends Reference implements Action {
  readonly type = FieldActionTypes.UPDATE_FIELD_SUCCESS;

  constructor() {
    super();
  }
}

export class UpdateFieldFailed extends Reference implements Action {
  readonly type = FieldActionTypes.UPDATE_FIELD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadLookupFields implements Action {
  readonly type = FieldActionTypes.LOAD_LOOKUP_FIELDS;

  constructor(
    public tableId: string,
    public force: boolean = false
  ) {}
}

export class LoadLookupFieldsSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_LOOKUP_FIELDS_SUCCESS;

  constructor(
    public tableId: string,
    public payload: Array<Field>
  ) {}
}

export class LoadLookupFieldsFailed implements Action {
  readonly type = FieldActionTypes.LOAD_LOOKUP_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadSummaryFields implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FIELDS;

  constructor(
    public fromTableId: string,
    public toTableId: string,
    public force: boolean = false
  ) {}
}

export class LoadSummaryFieldsSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FIELDS_SUCCESS;

  constructor(
    public fromTableId: string,
    public toTableId: string,
    public payload: Array<Field>
  ) {}
}

export class LoadSummaryFieldsFailed implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FIELDS_FAILED;

  constructor(public payload: Error) {}
}

export class LoadSummarizableFields implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARIZABLE_FIELDS;

  constructor(
    public tableId: string,
    public force: boolean = false
  ) {}
}

export class LoadSummarizableFieldsSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARIZABLE_FIELDS_SUCCESS;

  constructor(
    public tableId: string,
    public payload: Array<Field>
  ) {}
}

export class LoadSummarizableFieldsFailed implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARIZABLE_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class LoadFieldDependencies implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_DEPENDENCIES;

  constructor(
    public tableId: string,
    public fieldId: string,
    public force: boolean = false
  ) {}
}

export class LoadFieldDependenciesSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_DEPEDENCIES_SUCCESS;

  constructor(
    public tableId: string,
    public fieldId: string,
    public payload: FieldDependencies
  ) {}
}

export class LoadFieldDependenciesFailed implements Action {
  readonly type = FieldActionTypes.LOAD_FIELD_DEPENDENCIES_FAILED;

  constructor(public payload: Error) {}
}

export class LoadDependentFields implements Action {
  readonly type = FieldActionTypes.LOAD_DEPENDENT_FIELDS;

  constructor(
    public tableId: string,
    public fieldId: string
  ) {}
}

export class LoadDependentFieldsSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_DEPENDENT_FIELDS_SUCCESS;

  constructor(
    public tableId: string,
    public fieldId: string,
    public payload: DependentFieldsSuccess
  ) {}
}

export class LoadDependentFieldsFailed implements Action {
  readonly type = FieldActionTypes.LOAD_DEPENDENT_FIELDS_FAILED;

  constructor(public payload: Error) {}
}

export class LoadSummaryFormField implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FORM_FIELD;

  constructor(
    public tableId: string,
    public fieldId: string,
    public force: boolean = false
  ) {}
}

export class LoadSummaryFormFieldSuccess implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FORM_FIELD_SUCCESS;

  constructor(
    public tableId: string,
    public fieldId: string,
    public payload: Array<FormField>
  ) {}
}

export class LoadSummaryFormFieldFailed implements Action {
  readonly type = FieldActionTypes.LOAD_SUMMARY_FORM_FIELD_FAILED;

  constructor(public payload: Error) {}
}


export class Reset implements Action {
  readonly type = FieldActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadField
  | LoadFieldSuccess
  | LoadFieldFailed
  | LoadFields
  | LoadFieldsSuccess
  | LoadFieldsFailed
  | LoadFieldTypes
  | LoadFieldTypesSuccess
  | LoadFieldTypesFailed
  | CreateField
  | CreateFieldSuccess
  | CreateFieldFailed
  | CreateMultipleFields
  | CreateMultipleFieldsSuccess
  | CreateMultipleFieldsFailed
  | DeleteField
  | DeleteFieldSuccess
  | DeleteFieldFailed
  | UpdateField
  | UpdateFieldSuccess
  | UpdateFieldFailed
  | LoadLookupFields
  | LoadLookupFieldsSuccess
  | LoadLookupFieldsFailed
  | LoadSummaryFields
  | LoadSummaryFieldsSuccess
  | LoadSummaryFieldsFailed
  | LoadSummarizableFields
  | LoadSummarizableFieldsSuccess
  | LoadSummarizableFieldsFailed
  | LoadFieldDependencies
  | LoadFieldDependenciesSuccess
  | LoadFieldDependenciesFailed
  | LoadDependentFields
  | LoadDependentFieldsSuccess
  | LoadDependentFieldsFailed
  | LoadSummaryFormField
  | LoadSummaryFormFieldSuccess
  | LoadSummaryFormFieldFailed
  | CreateLookupFields
  | CreateLookupFieldsSuccess
  | CreateLookupFieldsFailed
  | Reset;
